import React from 'react'
import styled from 'styled-components'

import { Link } from '@ui/blocks/Link'
import { Image } from '@ui/blocks/Image'
import { Asset } from '@app/graphql/cms/schema'

export const ARTICLE_WIDTH = '31%'

export interface ArticleProps {
  id?: string
  title?: string
  articleUrl?: string
  image?: Partial<Asset> | null
  category?: {
    name: string
    url: string
  }
  isSlider?: boolean
}

const ArticleWrapper = styled.div<{ isSlider?: boolean }>`
  width: ${({ isSlider }) => (isSlider ? '100%' : ARTICLE_WIDTH)};
  margin-bottom: 4rem;
`
const ArticleImageWrapper = styled(Link)`
  object-fit: cover;
  width: 100%;
`

const ArticleCategory = styled(Link)`
  font-size: 1.6rem;
  line-height: 2.6rem;
  color: ${({ theme }) => theme.global.colors.elemyGreen};

  &:hover {
    color: ${({ theme }) => theme.global.colors.genoa};
  }
`

const ArticleCategoryWrapper = styled.div`
  margin-bottom: 0.8rem;
`

const ArticleTitle = styled(Link)`
  font-family: ${({ theme }) => theme.global.fontNames.serif};
  font-size: 2.2rem;
  line-height: 3.2rem;
  color: ${({ theme }) => theme.global.colors.elemyGreen};

  &:hover {
    color: ${({ theme }) => theme.global.colors.genoa};
  }

  @media ${({ theme }) => theme.device.tablet} {
    font-size: 2rem;
    line-height: 3.2rem;
  }
`

const ArticleImage = styled(Image)`
  object-fit: cover;
  width: 100%;
  height: 28.6rem;
  margin-bottom: 1.6rem;

  @media ${({ theme }) => theme.device.laptop} {
    height: 20rem;
  }

  @media ${({ theme }) => theme.device.tablet} {
    height: 44.7rem;
  }

  @media ${({ theme }) => theme.device.mobileL} {
    height: 33.8rem;
  }
`

export const Article = ({ title, image, category, articleUrl, isSlider }: ArticleProps) => {
  if (!title) {
    return null
  }

  return (
    <ArticleWrapper isSlider={isSlider}>
      {image && (
        <ArticleImageWrapper to={articleUrl || '/'}>
          <ArticleImage src={image.url} alt={title} />
        </ArticleImageWrapper>
      )}
      {category && (
        <ArticleCategoryWrapper>
          <ArticleCategory to={`/studio/${category.url}`}>{category.name}</ArticleCategory>
        </ArticleCategoryWrapper>
      )}
      {title && <ArticleTitle to={articleUrl || '/'}>{title}</ArticleTitle>}
    </ArticleWrapper>
  )
}
